import { NEAR_BLACK, FROSTED_BLACK, LIGHT_GRAY, NEAR_WHITE } from "@shape/reef-shared";
import styled from "styled-components";

export const Container = styled.div`
  outline: none;
  position: relative;
  width: 100%;
`;
export const Filter = styled.div<{ showOptions: boolean; background?: string }>`
  position: relative;
  z-index: ${({ showOptions }) => (showOptions ? "2" : "unset")};

  input {
    width: 100%;
    padding: 9px 40px 9px 15px;
    text-overflow: ellipsis;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid ${LIGHT_GRAY};
    background-color: ${({ background }) => background || "transparent"};

    color: ${NEAR_WHITE};
    font-size: 14px;
    transition: 0.2s ease;
    outline: none;
    cursor: default;
    ::placeholder {
      color: ${NEAR_WHITE};
    }

    &:hover,
    &:focus {
      border-color: ${LIGHT_GRAY};
      & + svg {
        color: ${LIGHT_GRAY};
      }
    }

    &:focus {
      cursor: text;
    }
  }

  svg {
    position: absolute;
    top: 11px;
    right: 18px;
    color: ${LIGHT_GRAY};
    pointer-events: none;

    &.fa-circle-notch {
      right: 15px;
      animation-duration: 0.8s;
    }
  }
`;

export const OptionsContainer = styled.div<{ hasOptions: boolean; isRelative?: boolean }>`
  position: ${({ isRelative }) => (isRelative ? "relative" : "absolute")};
  background: ${NEAR_BLACK};
  color: ${NEAR_WHITE};
  z-index: 1;
  width: 100%;
  font-size: 13px;
  padding: 4px 0px;
  border-radius: 0 0 4px 4px;
  transform-origin: top;
  animation: showOptions 0.2s ease;
  overflow: hidden;
  transition: max-height 0.2s ease;
  max-height: ${({ hasOptions }) => (hasOptions ? "125px" : "48px")};

  @keyframes showOptions {
    0% {
      margin-top: -40px;
      max-height: 48px;
      opacity: 0;
    }
    100% {
      margin-top: 0px;
      max-height: 125px;
      opacity: 1;
    }
  }
`;

export const Options = styled.div`
  max-height: 125px;

  .option {
    width: 100%;
    padding: 5px 12px;
    margin: 0px 4px;
    border-radius: 4px;
    cursor: pointer;
    outline: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:focus {
      border: 2px solid ${FROSTED_BLACK};
      padding: 3px 10px;
    }

    &:hover {
      background-color: ${FROSTED_BLACK};
    }
  }
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 16px;
  max-height: 48px;
`;

export const CreateOption = styled.button`
  display: block;
  width: calc(100% - 8px);
  margin: 4px;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  background: none;
  color: inherit;
  font: inherit;
  text-align: center;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${FROSTED_BLACK};
  }
`;
